export default {
  title: '! Encomendas pausadas até {{time}}',
  button: 'Retomar',
  labels: {
    rest_of_day: 'resto do dia',
  },
};
